import { useState } from "react";
import {
  createPaymentApi,
  getPaymentByTableApi,
  closePaymentApi,
  getPendingPaymentsApi,
  getPaymentsApi,
  getPaymentsInRangeApi,
  getLossesInRangeApi,
  voidPaymentApi,
  getVoidedPaymentsApi,
  discountPaymentApi,
  getDiscountedPaymentsApi,
  setPaymentGuestsApi,
  setPaymentCustomerApi,
  setPaymentTipApi,
  setPaymentDeliveryApi,
} from "../api/payment";
import { useAuth } from "./";

export function usePayment() {
  const { auth } = useAuth();
  // Solo con sesión válida (me.id): el Cliente de la mesa no tiene sesión, y
  // un token vencido guardado en ese celular haría que el backend rechace
  // incluso lo que el Cliente sí puede hacer sin login.
  const token = auth?.me?.id ? auth.token : null;
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [payments, setPayments] = useState(null);

  const createPayment = async (paymentData) => {
    try {
      return await createPaymentApi(paymentData, token);
    } catch (error) {
      setError(error);
    }
  };

  const getPaymentByTable = async (idTable) => {
    try {
      return await getPaymentByTableApi(idTable, token);
    } catch (error) {
      setError(error);
    }
  };

  const closePayment = async (
    idPayment,
    operationCode = "",
    cashReceived = null,
    parts = null,
    paymentType = null
  ) => {
    try {
      await closePaymentApi(idPayment, operationCode, token, cashReceived, parts, paymentType);
    } catch (error) {
      setError(error);
      throw error;
    }
  };

  const getPendingPayments = () => getPendingPaymentsApi(token);

  const getPayments = async (sortBy, dateFrom, dateTo) => {
    try {
      setLoading(true);
      const response = await getPaymentsApi(sortBy, dateFrom, dateTo, token);
      setLoading(false);
      setPayments(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const getPaymentsInRange = async (dateFrom, dateTo) => {
    try {
      setLoading(true);
      const response = await getPaymentsInRangeApi(dateFrom, dateTo, token);
      setLoading(false);
      setPayments(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const getLossesInRange = async (dateFrom, dateTo) => {
    try {
      setLoading(true);
      const response = await getLossesInRangeApi(dateFrom, dateTo, token);
      setLoading(false);
      setPayments(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  // Devuelven el resultado y dejan pasar el error (para mostrarlo en pantalla).
  const voidPayment = (idPayment, reason) => voidPaymentApi(idPayment, reason, token);
  const getVoidedPayments = (dateFrom, dateTo) =>
    getVoidedPaymentsApi(dateFrom, dateTo, token);
  const discountPayment = (idPayment, discount) =>
    discountPaymentApi(idPayment, discount, token);
  const getDiscountedPayments = (dateFrom, dateTo) =>
    getDiscountedPaymentsApi(dateFrom, dateTo, token);

  return {
    error,
    loading,
    payments,
    voidPayment,
    getVoidedPayments,
    discountPayment,
    getDiscountedPayments,
    setPaymentGuests: (idPayment, guests, waiter) =>
      setPaymentGuestsApi(idPayment, guests, token, waiter),
    setPaymentTip: (idPayment, tipCash, tipCard) =>
      setPaymentTipApi(idPayment, tipCash, tipCard, token),
    setPaymentCustomer: (idPayment, customerId) =>
      setPaymentCustomerApi(idPayment, customerId, token),
    setPaymentDelivery: (idPayment, channel, fee) =>
      setPaymentDeliveryApi(idPayment, channel, fee, token),
    createPayment,
    getPaymentByTable,
    closePayment,
    getPendingPayments,
    getPayments,
    getPaymentsInRange,
    getLossesInRange,
  };
}
